import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import Header from './Header';
import Overview from './Overview';
import Fiche from './Fiche';
import Logout from './Logout';

import api from '../../utils/api';

class Authenticated extends Component {
  componentDidMount() {
    api.post('/auth/me');
  }

  render() {
    return (
      <div className="App">
        <Header />

        <div className="App__Wrapper">
          <Switch>
            <Route exact path="/" component={Overview} />
            <Route exact path="/fiche" component={Fiche} />
            <Route exact path="/logout" component={Logout} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default Authenticated;
